<div class="flex flex-col flex-auto min-w-0">

    <!-- Main -->
    <div class="flex-auto">

        <!-- CONTENT GOES HERE -->
        <div class="h-full max-content-h">
            <div class="drk-page-wrapper">
                <div class="w-full bg-white shadow-md rounded-2xl p-6 mb-4">

                    <div class="grid grid-cols-1 sm:grid-cols-5 gap-4 items-center">
                        <div class="col-span-1">
                            <p class="text-sm">Ambito</p>
                            <kendo-combobox name="scope" [data]="scopes" [filterable]="true" textField="text"
                                [disabled]="thinking || scopeReceived" (valueChange)="onScopeChange($event)"
                                valueField="value" [valuePrimitive]="true" [(ngModel)]="aiConfig.scope"
                                placeholder="Seleziona l'ambito...">
                            </kendo-combobox>
                        </div>
                        <div class="col-span-1">
                            <p class="text-sm">Oggetto Analisi</p>
                            <kendo-textbox name="recordId" [(ngModel)]="aiConfig.recordId"
                                [disabled]="thinking || idReceived"
                                placeholder="Inserisci l'ID del record da analizzare..." class="flex-grow">
                            </kendo-textbox>
                        </div>

                        <div class="col-span-1">
                            <p class="text-sm">Richiesta</p>
                            <kendo-combobox name="prompt" [data]="prompts" [filterable]="true" textField="text"
                                [disabled]="thinking || !aiConfig.scope || prompts.length <= 1" valueField="value"
                                [valuePrimitive]="true" [(ngModel)]="aiConfig.prompt" (valueChange)="onPromptChange($event)"
                                placeholder="Seleziona la richiesta...">
                            </kendo-combobox>
                        </div>
                        <div class="col-span-1">
                            <p class="text-sm">Tipo Analisi</p>
                            <kendo-combobox name="model" [data]="models" [filterable]="true" textField="text"
                                [disabled]="thinking" valueField="value" [valuePrimitive]="true"
                                [(ngModel)]="aiConfig.model" placeholder="Seleziona il tipo...">
                            </kendo-combobox>
                        </div>
                        <div class="col-span-1">
                            <p class="text-sm">Processo</p>
                            <kendo-combobox name="process" [data]="workflows" [filterable]="true" textField="text"
                                [disabled]="thinking || (wf && workflows.length <= 1) " valueField="value" [valuePrimitive]="true"
                                [(ngModel)]="wf" placeholder="Seleziona il processo...">
                            </kendo-combobox>
                        </div>
                        <div class="col-span-1 row-span-2 self-start" [hidden]="true">
                            <p class="text-sm">File</p>
                            <kendo-upload 
                                [autoUpload]="false" 
                                [multiple]="true" 
                                (select)="onSelect($event)" 
                                [disabled]="thinking"
                                class="light-upload">
                            </kendo-upload>
                        </div>

                        <div class="col-span-5 items-center" ><!--[hidden]="aiConfig.prompt"-->
                            <p class="text-sm">Inserisci il tuo prompt</p>
                            <kendo-textarea [(ngModel)]="aiConfig.customPrompt" name="customPrompt"
                                [disabled]="thinking || aiConfig.prompt"
                                placeholder="Scrivi un prompt indicando il tipo di analisi da effettuare e il risultato che vuoi ottenere"></kendo-textarea>
                        </div>
                        <div class="col-span-6 text-center">
                            <kendo-button [svgIcon]="btnIcon" (click)="startAnalysis()" class="btn-default"
                                [disabled]="thinking || !aiConfig.scope  || (!aiConfig.prompt && !aiConfig.customPrompt) || !aiConfig.model">Avvia
                                Analisi</kendo-button>
                                <!-- || !aiConfig.recordId -->
                        </div>
                    </div>
                </div>

                <!-- Sezione inferiore -->
                <div class="w-full  bg-white shadow-md rounded-2xl p-6 ai-response-wrapper"
                    [class.smaller]="!aiConfig.prompt">

                    <div class="flex items-center space-x-4 mb-4">
                        <!-- Loader a sinistra -->
                        <div class="flex items-center w-full">
                            <!-- Loader a sinistra -->
                            <div class="flex items-center" *ngIf="!thinking && response?.length">
                                <h1 class="text-2xl font-bold text-center">Elaborazione Completata</h1>
                                <kendo-button [svgIcon]="printIcon" (click)="printPDF()" class="icon-only"
                                    [disabled]="thinking && !response"></kendo-button>
                                <kendo-button [svgIcon]="downloadIcon"
                                    (click)="downloadBase64File(f.content, f.metadata.Filename, f.metadata.MimeType)"
                                    class="icon-only" *ngFor="let f of generatedFiles"
                                    [disabled]="thinking && !response">{{f.metadata.Filename}}</kendo-button>
                            </div>
                            <div class="flex items-center" *ngIf="!thinking && error?.length">
                                <h1 class="text-2xl font-bold text-center">Errore di Elaborazione</h1>
                            </div>
                            <div class="flex items-center" *ngIf="thinking">
                                <h1 class="text-2xl font-bold text-center mr-2">{{currentOperation}} in corso</h1>
                                <div class="w-2 h-2 ai-thinking rounded-full animate-think delay-0"></div>
                                <div class="w-2 h-2 ai-thinking rounded-full animate-think delay-150"></div>
                                <div class="w-2 h-2 ai-thinking rounded-full animate-think delay-300"></div>

                            </div>

                            <!-- Div input/output a destra -->
                            <div *ngIf="!thinking && usage.INPUT.TOKENS > 0"
                                class="inline-flex items-center space-x-2 bg-gray-100 text-gray-800 text-sm px-3 py-1 rounded-full shadow-sm ml-auto">
                                <span>Input: <span class="text-blue-500 font-bold">{{usage.INPUT.TOKENS}} [€
                                        {{usage.INPUT.COST | number:'1.5-5'}}]</span></span>
                                <span>/</span>
                                <span>Output: <span class="text-blue-500 font-bold">{{usage.OUTPUT.TOKENS}} [€
                                        {{usage.OUTPUT.COST | number:'1.5-5'}}]</span></span>
                                <span>/</span>
                                <span>Tempo Elaborazione: <span
                                        class="text-green-500 font-bold">{{calculateTime(time)}}</span></span>
                            </div>
                        </div>

                    </div>
                    
                    <div [innerHTML]="response" class="text-gray-700 leading-relaxed ai-response-content"
                        [class.thinking]="thinking" *ngIf="response?.length" #aiResponse></div>
                    <div [innerHTML]="error" class="text-red-500 leading-relaxed ai-response-content"
                        [class.thinking]="thinking" *ngIf="error?.length"></div>
                </div>
            </div>
        </div>
    </div>
</div>